import {Component, OnInit, HostBinding, HostListener, Input} from '@angular/core';
import { SearchResultsService } from '../services/searchResults.service';
import { LocationService } from '../services/location.service';
import { Nursery } from '../models/Nursery';
import { mapStyles } from './mapStyles';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import { uniq } from 'lodash';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: []
})
export class MapComponent implements OnInit {
  directionsDisplay;
  map: google.maps.Map;
  mapOptions;
  greenIcon = {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 8,
    fillColor: '#000351',
    fillOpacity: 1,
    strokeColor: '#8ec351',
    strokeWeight: 10,
  };
  markers: google.maps.Marker[] = [];
  @Input() openNursery: Function;

  constructor(private locationService: LocationService, private searchResultsService: SearchResultsService) { }

  @HostBinding('style.height.px')
  height: number;
  @HostBinding('style.width.px')
  width: number;

  ngOnInit() {
    this.searchResultsService.resultsData.filter(r => r.length > 0).subscribe(data => {
      if (!this.map) return;

      this.markers.forEach(m => m.setMap(null));
      this.markers = [];

      if (data[0].item) {
        if (data[0].item.locations) {
          const nurseryLocations = uniq(data.map(d => d.item.locations).reduce((d, list) => list.concat(d)), 'id');
          this.markers = nurseryLocations.filter(n => n.lat_lng && n.lat_lng.lat && n.lat_lng.lng).map(nursery => this.setMarker(nursery));
          console.log('nursery locations', nurseryLocations);
          console.log('nursery markers', this.markers);
        } else {
          console.log('nurseries and nothign else', data);
          const searchData: any = data;
          this.markers = searchData.map(s => s.item).filter(n => n.lat_lng && n.lat_lng.lat && n.lat_lng.lng).map(nursery => this.setMarker(nursery));
          console.log('markers?', this.markers);
        }
      } else if (data[0]['locations']) {
        const nurseryLocations = uniq(data.map((d: any) => d.locations).reduce((d, list) => list.concat(d)), 'id');
        this.markers = nurseryLocations.filter(n => n.lat_lng && n.lat_lng.lat && n.lat_lng.lng).map(nursery => this.setMarker(nursery));
        console.log('nursery locations from products', nurseryLocations);
        console.log('nursery markers', this.markers);
      } else {
        const nurseries: any = data;
        // Just nursery business results
        this.markers = nurseries.filter(n => n.lat_lng && n.lat_lng.lat && n.lat_lng.lng).map(nursery => {
          return this.setMarker(nursery);
        });
        console.log('nursery only results', nurseries);
        console.log('nursery markers', this.markers);
      }
      this.centerMapCurrentLocation();
      // this.centerOnBounds(this.markers.map(m => m.getPosition()));
    });
  }

  private setMarker(nursery: Nursery) {
    const marker = new google.maps.Marker({
      map: this.map,
      title: nursery.name,
      icon: this.greenIcon,
      position: new google.maps.LatLng(nursery.lat_lng.lat, nursery.lat_lng.lng),
    });
    marker['nurseryId'] = nursery.id;
    const markerContent = nursery.name;
    const infoWindow = new google.maps.InfoWindow();
    const openNursery = this.openNursery;

    google.maps.event.addListener(marker, 'mouseover', () => {
      console.log(nursery.name, nursery.id);
    });

    google.maps.event.addListener(marker, 'click', (function(marker, content, infowindow, nursery, openNursery){
      return function() {
        infowindow.setContent(content);
        infowindow.open(this.map, marker);
        openNursery(nursery);
      };
    })(marker, markerContent, infoWindow, nursery, openNursery));

    google.maps.event.addListener(marker, 'dblclick', (function(marker, content, infowindow, nursery, openNursery){
      return function() {
        infowindow.setContent(content);
        infowindow.open(this.map, marker);
      };
    })(marker, markerContent, infoWindow, nursery, openNursery));

    return marker;
  }

  public initializeMap() {
    //M537.2102966308594,323.90161204338074q37.5,94.5,74,2
    this.directionsDisplay = new google.maps.DirectionsRenderer();


    this.locationService.location.filter(l => l !== null).first().subscribe(loc => {
      const { lat, lng } = loc;
      this.mapOptions = {
        center: new google.maps.LatLng(lat, lng),
        zoom: 6,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        mapTypeControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap', 'terrain'],
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: mapStyles
      };

      this.map = new google.maps.Map(document.getElementById('google-map'), this.mapOptions);
      this.directionsDisplay.setMap(this.map);
    });
  }

  public centerOnBounds(positions: google.maps.LatLng[]): void {
    const bounds = new google.maps.LatLngBounds();
    positions.forEach(p => bounds.extend(p));
    this.map.fitBounds(bounds);
  }

  public centerMap(location, zoom?) {
    this.map.setCenter(location);
    if (zoom) this.map.setZoom(zoom);
  }

  public centerMapCurrentLocation() {
    this.centerMap(this.locationService.location.value);
  }

  public displayDirections(directions, start, end, routeIndex = 0) {
    this.removeDirections();
    this.directionsDisplay.setDirections(directions);
  }

  public removeDirections() {
    this.directionsDisplay.set('directions', null);
  }

  public openPinInfo(nursery) {
    new google.maps.event.trigger(this.markers.find((m => m['nurseryId'] === nursery.id))[0], 'dblclick');
  }

  public showAllMarkers() {
    this.markers.forEach(m => m.setMap(this.map));
  }

  public hideAllMarkers() {
    this.markers.map(m => m.setMap(null));
  }

  public showMarkersGivenIds(nurseryIdsToShow: Array<number>) {
    this.markers.forEach(m => m.setMap(null));
    this.markers
      .filter(marker => nurseryIdsToShow.indexOf(marker['nurseryId']) >= 0)
      .forEach(marker => marker.setMap(this.map));
  }
}
